import React from "react";
import styled from "styled-components";
import { H6 } from "../typography/heading";

const StyledLabel = styled(H6)`
  display: block;
  margin-bottom: 10px;
`;

const Label = (props) => <StyledLabel left {...props} as="label" />;

export default Label;
